import React from 'react'

const Footer = () => {
    return (
        <section className="w-full py-10 border-b-[1px] border-b-black">
            <div className="flex justify-center items-center text-center">
                <p className="text-1xl font-bold text-white">COPYRIGHT © 2023- C-DEVOPS!</p>
            </div>
        </section>
    )
}

export default Footer
